import React from 'react'
import styled from 'styled-components'
import {GIFT_SHOP_HEADER_HEIGHT, IMAGE_ASSET} from 'consts'
import {useHistory} from 'utils'
import {useWindowMode} from 'windows'
import {WindowModeType} from 'types'
import {Image} from 'common/components'
import convertUnit from 'lib/unit'
import {PolicyRootNavBarItem} from '../NavBarItem'
import {PolicyRootNavBarProps} from './PolicyRootNavBarProps'

interface ContainerProps {
  expand: boolean
  mode: WindowModeType
}

const StyledContainer = styled.div<ContainerProps>`
  ${({theme}) => ({
    borderColor: theme.gray_1,
    backgroundColor: theme.white_1,
  })}
  display: flex;
  position: absolute;
  height: 100%;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  border-right-style: solid;
  border-right-width: ${convertUnit(1)};
  height: ${({mode, expand}) =>
    expand && mode !== 'website' ? GIFT_SHOP_HEADER_HEIGHT : undefined};
`

const StyledScrollContainer = styled.div`
  overflow-y: scroll;
  ::-webkit-scrollbar {
    background-color: ${({theme}) => theme.white_3};
    width: ${convertUnit(0)};
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${({theme}) => theme.primary_5};
    background-clip: content-box;
    border-radius: ${convertUnit(0)};
  }
`

const StyledLogo = styled.div`
  margin: ${convertUnit(20)} 0;
  text-align: center;
  cursor: pointer;
`
const StyledListItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export default function PolicyRootNavBar({
  select,
  data,
  expand,
}: PolicyRootNavBarProps) {
  const history = useHistory()
  const mode = useWindowMode()
  const fotoyulogo = IMAGE_ASSET('giftshop', 'logo-fotoyu-cms.png')

  return (
    <StyledContainer mode={mode} expand={expand}>
      <StyledLogo onClick={() => history.push('giftshop_feed', {})}>
        <Image src={fotoyulogo} alt="Fotoyu Logo" />
      </StyledLogo>
      <StyledScrollContainer>
        {data.map(({key, label, onClick}) => (
          <StyledListItemContainer key={key}>
            <PolicyRootNavBarItem
              label={label}
              isSelected={select === key}
              onClick={onClick}
            />
          </StyledListItemContainer>
        ))}
      </StyledScrollContainer>
    </StyledContainer>
  )
}
